import { useEffect, useState } from "react";
import { Navigate, Link } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import ProductCard from "../components/ProductCard";

export default function Wishlist() {
  const { user, loading } = useAuth();
  const [items, setItems] = useState([]);
  const [fetching, setFetching] = useState(true);

  useEffect(() => {
    if (user && user !== false) {
      setFetching(true);
      api
        .get("/wishlist")
        .then((r) => setItems(r.data))
        .finally(() => setFetching(false));
    }
  }, [user]);

  if (loading) return <div className="text-white/50 text-center py-32">Loading...</div>;
  if (!user || user === false) return <Navigate to="/login" replace />;

  return (
    <div data-testid="wishlist-page" className="max-w-7xl mx-auto px-4 md:px-8 py-12">
      <span className="tag tag-accent">// FAVORITES</span>
      <h1 className="font-display font-black text-3xl md:text-5xl tracking-tighter text-white mt-3 mb-8">
        My Wishlist
      </h1>
      {fetching ? (
        <p className="text-white/50">Loading...</p>
      ) : items.length === 0 ? (
        <div data-testid="empty-wishlist" className="border border-white/10 p-12 text-center text-white/60">
          No favorites yet.{" "}
          <Link to="/browse" className="text-[#00F0FF] hover:underline">
            Find something you like
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {items.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      )}
    </div>
  );
}
